import { initI18n } from 'hive-react-utils';

import { en } from '../i18n/en';
import { fr } from '../i18n/fr';

initI18n({ en, fr });
